import paths from "@icarius-router/paths";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("evaluatedCode"),
            field: "evaluatedCode",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("evaluatedName"),
            field: "evaluatedName",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("finalPerformanceGrade"),
            field: "performanceFinalScore",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("finalPerformanceScore"),
            field: "performanceFinalValue",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("finalPotentialScoreAlternative"),
            field: "potentialFinalScore",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("finalPotentialScore"),
            field: "potentialFinalValue",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config: {
            headerName: getLocalizedString("nineBoxClassification"),
            field: "nineBoxClassification",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config: {
            headerName: getLocalizedString("calibratedFrom9Boxes"),
            field: "nineBoxCalibration",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("quadrantClassification"),
            field: "quadrantClassification",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: 'NineBoxImageRenderer'
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("feedbacksReceivedDuringPeriod"),
            field: "feedbacksReceived",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("feedbackRequestedInPeriod"),
            field: "feedbacksRequested",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("recognitionPointsReceived"),
            field: "recognitionPoints",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("meritsReceived"),
            field: "merits",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("demeritsReceived"),
            field: "demerits",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: "NPS",
            field: "nps",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: 'NPSRenderer'
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("salaryUnit"),
            field: "salaryUnit",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("coin"),
            field: "coin",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsEvaluations],
        config:
        {
            headerName: getLocalizedString("salary"),
            field: "salary",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
]